import { render, staticRenderFns } from "./EmptyPlaceholder.vue?vue&type=template&id=44125459&scoped=true&"
import script from "./EmptyPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./EmptyPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyPlaceholder.vue?vue&type=style&index=0&id=44125459&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.9.8_m6jvttnwtqqy6l4pi5vsxiehsy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44125459",
  null
  
)

export default component.exports